import { default as config } from "common/config/config";
import styled, { css } from "styled-components";
import FormGridRow from "ui/common/components/layout/FormGrid/FormGridRow/FormGridRow";

export const FormGridBannerRoot = styled(FormGridRow)(
    () => css`
        .form-grid-input {
            padding: 0;
            max-width: ${config.validators.partner.bannerWidth}px;
        }
        .image-upload,
        .form-grid-input {
            width: 100%;
        }

        .form-grid-left-cell {
            justify-content: unset;
            padding-top: 0;
        }
    `,
);
